import { Radio } from "antd";
import Skeleton from "components/skeleton";
import Header from "components/header";

import { useTranslation } from "react-i18next";

const AddressList = ({ addressList, onChangeAddress, address, loading }) => {
  const { t } = useTranslation();

  const renderAddressItems = () => {
    return loading ? (
      <Skeleton loading={loading} />
    ) : addressList.length ? (
      addressList?.map((item) => {
        return (
          <Radio.Group
            onChange={onChangeAddress}
            value={address}
            className="flex flex-col mt-5"
          >
            <Radio
              className={`p-4 shadow-xs bg-white  rounded-lg  body-14px-regular  ${
                address === item?.id && "body-14px-demibold "
              } `}
              value={item?.id}
            >
              <div>{item.address}</div>
              <div className="flex gap-1">
                <span>{t("card-page.postcode")}</span>
                <span>{item.postal_code}</span>
              </div>
            </Radio>
          </Radio.Group>
        );
      })
    ) : (
      ""
    );
  };

  return (
    <div className="mx-5 mt-4">
      <Header title={`${t("card-page.address-destination")}`} />
      {renderAddressItems()}
    </div>
  );
};
export default AddressList;
